module.exports = __webpack_public_path__ + "img/weixin-1.e54d8e45.png";